import { render } from "./SalesByCategory.vue?vue&type=template&id=62ae747f&ts=true"
import script from "./SalesByCategory.vue?vue&type=script&lang=ts"
export * from "./SalesByCategory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__